import StartView from "./StartView";
import DeviceListView from "./DeviceListView";
//import AddDeviceView from "./AddDeviceView";
import DeviceView from "./DeviceView";
import DeviceStartView from "./DeviceStartView";
import DeviceApplicationListView from "./DeviceApplicationListView";
import DeviceApplicationView from "./DeviceApplicationView";
import DeviceDocumentView from "./DeviceDocumentView";
import ContactView from "./ContactView";
import ContactRegionView from "./ContactRegionView";
import TermsOfServiceView from "./TermsOfServiceView";
import DeviceRuntimeReportsView from "./DeviceRuntimeReportsView";
import DeviceMaintenanceView from "./DeviceMaintenanceView";
import DeviceSendServiceDataView from "./DeviceSendServiceDataView";
import DeviceViewServiceRecordView from "./DeviceViewServiceRecordView";
import DeviceSetupServiceParametersView from "./DeviceSetupServiceParametersView";
import DeviceLocationView from "./DeviceLocationView";
import DeviceWarrantyInfoView from "./DeviceWarrantyInfoView";
import DeviceSpecificationsView from "./DeviceSpecificationsView";
import DeviceTroubleshootingView from "./DeviceTroubleshootingView";
import LoginView from "./LoginView";
import RegistrationView from "./RegistrationView";
import DeviceOperatingDataView from "./DeviceOperatingDataView";
import DeviceDocumentationView from "./DeviceDocumentationView";
import DeviceQuickGuidesView from "./DeviceQuickGuidesView";
import DeviceServiceOperationsView from "./DeviceServiceOperationsView";
import RegisterDeviceView from "./RegisterDeviceView";
import InviteUserView from "./InviteUserView";
export var routes = [
    { name: "Start", path: "/", component: StartView, },
    { name: "Login", path: "/login", component: LoginView, },
    { name: "DeviceList", path: "/devices", component: DeviceListView },
    { name: "Registration", path: "/register", component: RegistrationView },
    //{ name: "AddDevice", path: "/add-device", component: AddDeviceView },
    {
        path: "/devices/:serial",
        component: DeviceView,
        children: [
            { name: "DeviceStart", path: "", component: DeviceStartView },
            { name: "OperatingData", path: "operating-data", component: DeviceOperatingDataView },
            { name: "DeviceRuntimeReports", path: "operating-data/runtime-reports", component: DeviceRuntimeReportsView },
            { name: "DeviceDocumentation", path: "documentation", component: DeviceDocumentationView },
            { name: "DeviceQuickGuides", path: "quick-guides", component: DeviceQuickGuidesView },
            { name: "RegisterDevice", path: "register", component: RegisterDeviceView },
            { name: "DeviceServiceOperations", path: "service-operations", component: DeviceServiceOperationsView },
            { name: "DeviceMaintenance", path: "maintenance", component: DeviceMaintenanceView },
            { name: "DeviceSendServiceData", path: "send-service-data", component: DeviceSendServiceDataView },
            { name: "DeviceServiceRecord", path: "service-record", component: DeviceViewServiceRecordView },
            { name: "DeviceSetupServiceParameters", path: "setup-service-parameters", component: DeviceSetupServiceParametersView },
            { name: "DeviceLocation", path: "location", component: DeviceLocationView },
            { name: "DeviceWarrantyInfo", path: "warranty-info", component: DeviceWarrantyInfoView },
            { name: "Specifications", path: "specifications", component: DeviceSpecificationsView },
            { name: "DeviceTroubleshooting", path: "troubleshooting", component: DeviceTroubleshootingView },
            { name: "InviteUser", path: "invite-user", component: InviteUserView },
            { name: "DeviceApplicationList", path: "applications", component: DeviceApplicationListView, },
            { name: "DeviceApplication", path: "applications/:applicationId", component: DeviceApplicationView, },
            { name: "DeviceDocument", path: "documents/:documentId", component: DeviceDocumentView, },
        ],
        meta: { hasChildren: true }
    },
    { name: "Contact", path: "/contact", component: ContactView },
    { name: "ContactRegion", path: "/contact/regions/:regionPath*", component: ContactRegionView },
    { name: "TermsOfService", path: "/terms-of-service", component: TermsOfServiceView },
    // Redirect unknown routes to home view
    { path: "*", redirect: "/" },
];
